/**
 * Redux actions for auth.
 * @module redux/actions/auth
 */

import { push } from "react-router-redux";
import { createAction } from "redux-actions";
import { login as apiLogin } from "../api/auth";
import { getUserProfile as apiGetUserProfile } from "../api/axis";
import { actions as savedStateActions } from "./savedState";

export const LOGIN_REQUEST = "AUTH/LOGIN_REQUEST";
export const LOGIN_SUCCESS = "AUTH/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "AUTH/LOGIN_FAILURE";
export const RECEIVED_AXIS_USER_PROFILE = "AUTH/RECEIVED_AXIS_USER_PROFILE";
export const REQUEST_AXIS_USER_PROFILE = "AUTH/REQUEST_AXIS_USER_PROFILE";
export const REQUEST_AXIS_USER_PROFILE_FAILED =
  "AUTH/REQUEST_AXIS_USER_PROFILE_FAILED";

const loginRequest = createAction(LOGIN_REQUEST);
const loginSuccess = user => createAction(LOGIN_SUCCESS)({ user });
const loginFailure = redirect => dispatch => {
  dispatch(createAction(LOGIN_FAILURE)());
  if (redirect) {
    dispatch(redirectToLogin());
  }
};
const receivedAxisUserProfile = userProfile =>
  createAction(RECEIVED_AXIS_USER_PROFILE)({
    projects: userProfile.projects,
    services: userProfile.services,
    canCreateOrders: userProfile.canCreateOrders,
    hasAccessToApGraphics: userProfile.hasAccessToApGraphics,
    hasAccessToMgnGraphics: userProfile.hasAccessToMgnGraphics
  });

function redirectPostLogin() {
  return dispatch => {
    // Go Back to the last page prior to be redirected to login.
    dispatch(push("/assets"));
  };
}

function redirectToLogin() {
  return dispatch => {
    dispatch(push("/login"));
  };
}

/**
 * Performs a login action to create a new ASP.net session.
 * @param  {string} userName The supplied username.
 * @param {bool} redirect Whether to redirect after login.
 * @param {bool} override Whether to lock the username to prevent other logins.  For overriding.
 * @param {bool} ignoreFailure Whether to ignore redirect to login page after failed login
 */
export function login(userName, redirect, override, ignoreFailure) {
  return (dispatch, getState) => {
    const currentRoute = getState().routing.locationBeforeTransitions.pathname;
    if (!userName) {
      console.log("Checking for existing authentication session.");
    } else {
      console.log(`Attempting to login as ${userName}`);
    }
    if (
      (!getState().auth.isLoggingIn && !getState().auth.authenticated) ||
      override
    ) {
      dispatch(loginRequest());
      apiLogin(userName)
        .then(response => {
          if (response.userId !== -1) {
            console.log(`Logged in as: ${response.username}`);
            dispatch(loginSuccess(response));
            dispatch(savedStateActions.getSavedState());
            if (redirect || currentRoute === "/login") {
              return dispatch(redirectPostLogin());
            }
            return Promise.resolve();
          }
          if (!userName) {
            console.log("No active user session detected");
          }
          return dispatch(
            loginFailure(!ignoreFailure && currentRoute !== "/login")
          );
        })
        .catch(error => {
          console.error(error);
          if (!userName) {
            console.log("No active user session detected");
          }
          return dispatch(
            loginFailure(!ignoreFailure && currentRoute !== "/login")
          );
        });
    }
  };
}

export function getAxisUserProfile() {
  return (dispatch, getState) => {
    if (!getState().auth.axisUserProfile.loading) {
      dispatch(createAction(REQUEST_AXIS_USER_PROFILE)());
      apiGetUserProfile()
        .then(
          (
            response // Have to parse this JSON again for some reason.
          ) => {
            const json = JSON.parse(response);
            if (json.status.code === 200) {
              return dispatch(receivedAxisUserProfile(json.response));
            }

            console.error(response);
            return dispatch(createAction(REQUEST_AXIS_USER_PROFILE_FAILED)());
          }
        )
        .catch(error => {
          console.error(error);
          return dispatch(createAction(REQUEST_AXIS_USER_PROFILE_FAILED)());
        });
    }
  };
}

export const actions = {
  login
};



// WEBPACK FOOTER //
// ./app/actions/auth.js